import React, {
  useEffect,
  useContext,
  useRef,
  Fragment,
  useState,
} from "react";
import { AppContext } from "../../context";
import {
  addImageToList,
  setLog,
  userLogs,
  patLogs,
  getConstraint,
  getAspectRatioClientList,
  setCameraOpenFlag,
  getCameraOpenFlag,
  getDocumentTagIndex,
  getWebpImageFormat,
  getImgQualityFactor
} from "../../context/utils";
import cameraImg from "../../img/camera.png";
import Rotate from "../Rotate";
import VINImg from "../../img/VINPopup.png";
import dashboard from "../../img/dashboard.jpg";

let imageCaptured = false;
let image = {};
let track = null;
let imgUrl = null;
let logBugs = true;
let videoEl;
let timeout = null;

const WondleSingleImage = () => {
  const {
    inspectionId,
    clientId,
    config,
    currentBlock,
    setCurrentBlock,
    isLandscape,
    setLandscape,
    subCondition,
    setSubCondition,
    subMandatory,
    setSubMandatory,
    isIOS
  } = useContext(AppContext);

  let webCamPromise = null;

  //Reference vaiables
  const singleScreen = useRef();
  const videoRef = useRef();
  const canvasRef = useRef();
  const startBtn = useRef();
  const imgRef = useRef();
  const backRef = useRef();
  const divImgRef = useRef();
  const guidanceTextRef = useRef();
  const redLineVINcontainer = useRef();
  const cardRef = useRef();
  const cardDashboardRef = useRef();
  const cardDashboardRef1 = useRef();
  const noRef = useRef();
  const yesRef = useRef();

  const land = () => window.innerWidth > window.innerHeight * 1.2;

  if (logBugs) {
    patLogs(`Entered to ${currentBlock.tag}`, inspectionId);
    userLogs({
      position: 8,
      last_page: `${currentBlock.tag} Module`,
      inspectionId,
    });
  }
  logBugs = false;

  const startCamera = () => {
    try {
      if (timeout) clearTimeout(timeout);
      webCamPromise = navigator.mediaDevices
        .getUserMedia(getConstraint(config, clientId))
        .then((stream) => {
          const elements = document.querySelectorAll(".pingsPort");
          elements.forEach((element) => {
            element.style.top = "0px";
            element.style.right = "0px";
            element.style.left = "10px";
          });
          if (window.stream) {
            window.stream.getTracks().forEach(track => track.stop());
            window.stream = null;
          }
          window.stream = stream;
          track = stream.getTracks()[0]
          videoEl = videoRef.current;
          if (videoEl) {
            videoEl.srcObject = stream;
            videoEl.onloadedmetadata = () => {
              if (imgUrl) {
                divImgRef.current.src = imgUrl;
                imgRef.current.style.display = "block";
              }

              if (currentBlock["tag"] === "VIN") {
                if (
                  !Object.keys(config["single-image"]).includes("vin_popup") &&
                  !config["single-image"]["vin_popup"]
                ) {
                  setTimeout(() => {
                    if (startBtn.current) startBtn.current.style.display = "block";
                  }, 300);
                }
              } else {
                setTimeout(() => {
                  if (startBtn.current) startBtn.current.style.display = "block";
                }, 500);
              }
              setCameraOpenFlag(true);
            };
          }
          else {
            setTimeout(() => {
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.onloadedmetadata = () => {
                  if (imgUrl) {
                    divImgRef.current.src = imgUrl;
                    imgRef.current.style.display = "block";
                  }
                  setCameraOpenFlag(true);
                  if (currentBlock["tag"] === "VIN") {
                    if (
                      !Object.keys(config["single-image"]).includes("vin_popup") &&
                      !config["single-image"]["vin_popup"]
                    ) {
                      setTimeout(() => {
                        if (startBtn.current) startBtn.current.style.display = "block";
                      }, 500);
                    }
                  } else {
                    setTimeout(() => {
                      if (startBtn.current) startBtn.current.style.display = "block";
                    }, 500);
                  }
                };
              }
            }, 200);
          }
        });
    } catch (error) {
      // console.log(error);
    }
  };

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      return text;
    }
  };

  const captureImg = () => {
    const cnv = canvasRef.current;
    const vw = videoRef.current;
    cnv.width = vw.videoWidth;
    cnv.height = vw.videoHeight;
    cnv.getContext("2d").drawImage(vw, 0, 0);
    const imgData = getWebpImageFormat() && !isIOS
      ? cnv.toDataURL("image/webp", getImgQualityFactor())
      : cnv.toDataURL("image/jpeg");
    imgUrl = imgData;
    divImgRef.current.src = imgData;
    let region = Object.keys(config["video-page"]).includes("clientRegion")
      ? config["video-page"]["clientRegion"]
      : "eu-central-1";
    image = {
      name: `${currentBlock["tag"]}.jpg`,
      imgData: imgData,
      tag: `${currentBlock["tag"]}`,
      web_region: null,
      angle: null,
      region: region,
      videoData: null,
      portraitApp: true,
      dialStatus: null,
      currentBlockName: currentBlock["id"]
    };
    if (startBtn.current) startBtn.current.style.display = "none";

    imgRef.current.style.display = "block";
    noRef.current.style.display = "inline-block";
    yesRef.current.style.display = "inline-block";
  };

  const imageRetake = () => {
    imgUrl = null;
    if (startBtn.current) startBtn.current.style.display = "block";
    imgRef.current.style.display = "none";
  };

  const imageNext = () => {
    logBugs = true;
    if (imageCaptured) return;
    patLogs(
      `tick button clicked and image is sent for uploading , ${currentBlock["tag"]} module is completed`,
      inspectionId
    );
    setCameraOpenFlag(false);
    imageCaptured = true;

    // Mark as completed in the parent blocks
    let tempSubMandatory = { ...subMandatory };
    Object.keys(tempSubMandatory).forEach((parentKey) => {
      if (tempSubMandatory[parentKey] && tempSubMandatory[parentKey][currentBlock.name] !== undefined) {
        tempSubMandatory[parentKey][currentBlock.name] = "completed";
      }
    });
    setSubMandatory(tempSubMandatory);

    let tempSubCondition = { ...subCondition };
    Object.keys(tempSubCondition).forEach((parentKey) => {
      if (tempSubCondition[parentKey] && tempSubCondition[parentKey][currentBlock.name] !== undefined) {
        tempSubCondition[parentKey][currentBlock.name] = "completed";
      }
    });
    setSubCondition(tempSubCondition);

    const elements = document.querySelectorAll(".pingsPort");
    elements.forEach((element) => {
      element.style.top = "10px";
      element.style.left = "";
      element.style.right = "";
    });

    setLog(`${currentBlock["tag"]} was captured`);
    addImageToList(image, "No Conversion");
    window.stream = null;
    if (track) track.stop();
    imgUrl = null;

    // Go back to the parent block (WondleMultipleImage)
    setCurrentBlock(config["blocks"][0]);
  };

  const back = () => {
    logBugs = true;
    patLogs("back button clicked", inspectionId);
    window.stream = null;
    if (track) track.stop();
    setCameraOpenFlag(false);

    const elements = document.querySelectorAll(".pingsPort");
    elements.forEach((element) => {
      element.style.top = "10px";
      element.style.left = "";
      element.style.right = "";
    });

    // Go back to the parent block (WondleMultipleImage)
    setCurrentBlock(config["blocks"][0]);
  };

  const setWhiteBlock = () => {
    // No-op for now, using blockRef display instead
  }

  useEffect(() => {
    if (Object.keys(config["single-image"]).includes("instruction1_tag") && [config["single-image"]["instruction1_tag"]].includes(currentBlock["tag"])) cardDashboardRef.current.style.display = "flex";
    if (Object.keys(config["single-image"]).includes("instruction2_tag") && [config["single-image"]["instruction2_tag"]].includes(currentBlock["tag"])) cardDashboardRef1.current.style.display = "flex";
    startCamera();
    setLandscape(land());
    setWhiteBlock();
    imgUrl = null;
    imageCaptured = false;
  }, []);


  useEffect(() => {
    const handleResize = () => {
      setLandscape(land());
      if (land()) setCameraOpenFlag(false);
      else if (!land()) {
        if (!getCameraOpenFlag()) setTimeout(() => startCamera(), 100);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (window.stream) {
        window.stream.getTracks().forEach(track => track.stop());
        window.stream = null;
      }
    }
  }, []);

  return (
    <Fragment>
      {isLandscape ? (
        <Rotate />
      ) : (
        <div
          id="vin-screen"
          ref={singleScreen}
          style={{
            height: "100dvh",
            overflowY: "auto"
          }}
        >
          <canvas
            ref={canvasRef}
            id="ios-canvas"
            style={
              getAspectRatioClientList(clientId, config)
                ? {
                  width: "100vw",
                  height: "100vh",
                  objectFit: "contain",
                  backgroundColor: "black",
                }
                : {}
            }
          ></canvas>
          <video
            ref={videoRef}
            id="videoWindow"
            style={
              getAspectRatioClientList(clientId, config)
                ? {
                  width: "100vw",
                  height: "100vh",
                  objectFit: "contain",
                  backgroundColor: "black",
                }
                : {}
            }
            autoPlay
            playsInline
          ></video>

          <div ref={cardDashboardRef} id="display-card-dashboard" style={{ flexDirection: "column", paddingBottom: "20px" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", paddingTop: "5%" }}>
              <div id="image-container" style={{ width: "90%", display: "flex", justifyContent: "center" }}>
                <img style={{ width: "80%", borderRadius: "5%" }} src={dashboard}></img>
              </div>
              <div id="dashboard-points" style={{ width: "90%", padding: "5%" }}>
                <div style={{ display: "flex", gap: "2%", marginBottom: "10px" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", fontSize: "14px" }}>{Object.keys(config["single-image"]).includes("document-inst")
                    ? config["single-image"]["document-inst"]["inst-One"]
                    : getTranslateText("Photo of the interior of the vehicle that must show the steering wheel, radio, and glove compartment.")}</p>
                </div>
                <div style={{ display: "flex", gap: "2%", marginBottom: "10px" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", fontSize: "14px" }}>{Object.keys(config["single-image"]).includes("document-inst")
                    ? config["single-image"]["document-inst"]["inst-Two"]
                    : getTranslateText("To get a good photo, we recommend taking it from the back seat, between the headrests of the front seats, so the entire dashboard is visible.")}</p>
                </div>
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", fontSize: "14px" }}>{Object.keys(config["single-image"]).includes("document-inst")
                    ? config["single-image"]["document-inst"]["inst-Three"]
                    : getTranslateText("The photo will be considered incorrect if it is cut off at any point or if an object prevents the dashboard from being seen completely.")}</p>
                </div>
              </div>
            </div>
            <div id="btn-container" style={{ paddingBottom: "unset", width: "100%", display: "flex", justifyContent: "center" }}>
              <button
                style={{
                  backgroundColor: config["colors"]["btn"],
                  color: "white",
                  width: "80%",
                  padding: "15px",
                  borderRadius: "10px",
                  border: "none",
                  fontSize: "16px",
                  fontWeight: "bold"
                }}
                onClick={() => {
                  cardDashboardRef.current.style.display = "none";
                  redLineVINcontainer.current.style.display = "flex";
                  startBtn.current.style.display = "block";
                }}
              >
                {Object.keys(config["video-page"]).includes("continueText")
                  ? config["video-page"]["continueText"]
                  : getTranslateText("Continue")}
              </button>
            </div>
          </div>

          <div ref={cardDashboardRef1} id="display-card-dashboard" style={{ flexDirection: "column", paddingBottom: "20px" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", paddingTop: "5%" }}>
              <div id="image-container" style={{ width: "90%", display: "flex", justifyContent: "center" }}>
                <img style={{ width: "80%", borderRadius: "5%" }} src={Object.keys(config["single-image"]).includes("document-inst1_img") ? config["single-image"]["document-inst1_img"] : "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/odometerInstruction.jpg"}></img>
              </div>
              <div id="dashboard-points" style={{ width: "90%", padding: "5%" }}>
                <div style={{ display: "flex", gap: "2%", marginBottom: "10px" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", fontSize: "14px" }}>{Object.keys(config["single-image"]).includes("document-inst1")
                    ? config["single-image"]["document-inst1"]["inst-One"]
                    : getTranslateText("Start the vehicle and keep the engine idling (RPM at 0).")}</p>
                </div>
                <div style={{ display: "flex", gap: "2%", marginBottom: "10px" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", fontSize: "14px" }}>{Object.keys(config["single-image"]).includes("document-inst1")
                    ? config["single-image"]["document-inst1"]["inst-Two"]
                    : getTranslateText("Ensure the total mileage (odometer reading) is clearly visible.")}</p>
                </div>
                <div style={{ display: "flex", gap: "2%" }}>
                  <div className="car-black"></div>
                  <p style={{ margin: "0px", padding: "0px", fontSize: "14px" }}>{Object.keys(config["single-image"]).includes("document-inst1")
                    ? config["single-image"]["document-inst1"]["inst-Three"]
                    : getTranslateText("Capture the complete instrument panel, including the speedometer and tachometer.")}</p>
                </div>
              </div>
            </div>
            <div id="btn-container" style={{ paddingBottom: "unset", width: "100%", display: "flex", justifyContent: "center" }}>
              <button
                style={{
                  backgroundColor: config["colors"]["btn"],
                  color: "white",
                  width: "80%",
                  padding: "15px",
                  borderRadius: "10px",
                  border: "none",
                  fontSize: "16px",
                  fontWeight: "bold"
                }}
                onClick={() => {
                  cardDashboardRef1.current.style.display = "none";
                  redLineVINcontainer.current.style.display = "flex";
                  startBtn.current.style.display = "block";
                }}
              >
                {Object.keys(config["video-page"]).includes("continueText")
                  ? config["video-page"]["continueText"]
                  : getTranslateText("Continue")}
              </button>
            </div>
          </div>

          {["VIN"].includes(currentBlock["tag"]) && (
            <div ref={cardRef} id="display-card-vin">
              <div id="image-container" style={{ width: "90%", display: "flex", justifyContent: "center" }}>
                <img style={{ width: "80%" }} src={Object.keys(config["single-image"]).includes("vin_popup_img") ? config["single-image"]["vin_popup_img"] : VINImg}></img>
              </div>
              <div id="btn-container" style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }}>
                <button
                  style={{
                    backgroundColor: config["colors"]["btn"],
                    color: "white",
                    width: "80%",
                    padding: "15px",
                    borderRadius: "10px",
                    border: "none",
                    fontSize: "16px",
                    fontWeight: "bold"
                  }}
                  onClick={() => {
                    cardRef.current.style.display = "none";
                    redLineVINcontainer.current.style.display = "flex";
                    startBtn.current.style.display = "block";
                  }}
                >
                  {Object.keys(config["single-image"]).includes("btnVinText")
                    ? config["single-image"]["btnVinText"]
                    : getTranslateText("Ok got it")}
                </button>
              </div>
            </div>
          )}
          {/* redLineVINcontainerView Removed */}
          <div
            ref={startBtn}
            style={{
              backgroundImage: `url(${cameraImg})`,
              backgroundSize: "37px 37px",
              backgroundRepeat: "no-repeat",
              objectFit: "cover",
              backgroundPosition: "center",
            }}
            onClick={captureImg}
            id="port-btn-vin-start"
          ></div>
          <div style={{ zIndex: "2" }} className="back-btn">
            <i className="fas fa-arrow-left fa-2x" onClick={() => back()}></i>
          </div>
          {Object.keys(currentBlock).includes("cameraInstruction") && (
            <div className="camerInst">
              <p>{currentBlock["cameraInstruction"]}</p>
            </div>
          )}
          <div
            id="vin-image"
            style={
              getAspectRatioClientList(clientId, config)
                ? { backgroundColor: "black", objectFit: "contain" }
                : {}
            }
            ref={imgRef}
          >
            <img
              ref={divImgRef}
              style={
                getAspectRatioClientList(clientId, config)
                  ? { objectFit: "contain" }
                  : { width: "100vw", height: "100vh" }
              }
            />
            <i
              className="fas fa-times fa-2x vin-btn-retake"
              ref={noRef}
              style={{
                display: "none",
                bottom: "20%",
                backgroundColor: config["colors"]["btn"],
              }}
              onClick={imageRetake}
            ></i>
            <i
              className="fas fa-check fa-2x vin-btn-next"
              ref={yesRef}
              style={{
                display: "none",
                bottom: "20%",
                backgroundColor: config["colors"]["btn"],
              }}
              onClick={imageNext}
            ></i>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default WondleSingleImage;
